import { render, staticRenderFns } from "./remove_insurance.vue?vue&type=template&id=79b65cf1"
import script from "./remove_insurance.vue?vue&type=script&lang=js"
export * from "./remove_insurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports